<template>
  <el-button
    :disabled="isDisabled"
    :loading="loadingSubmit"
    :style="styles"
    @click="handleAction"
    class="button-pay-custom"
    >{{ objectData.title }}</el-button
  >
</template>

<script>
import { getBackGround } from "../../../utils/wapAuth";

export default {
  components: {}, //, Comment
  bodyClass: "btn-action",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    loadingSubmit: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => {}
    },
    objectData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bg: getBackGround()
    };
  },
  created() {},

  watch: {},

  methods: {
    handleAction() {
      this.$emit("on-action", { reload: true });
    }
  },
  computed: {},
  mounted() {},

  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.button-pay-custom {
  width: 100%;
  height: 40px;
  border-radius: v-bind("bg.b_radius2");
  background: v-bind("bg.c_box_header_tee2");
  color: #ffffff;
}
.button-pay-custom:hover {
  background: v-bind("bg.c_box_header_tee2");

  color: #ffff;
}
.button-pay-custom:focus {
  background: v-bind("bg.c_box_header_tee2");

  color: #ffff;
}
</style>
